import React from "react";
import { Link } from "react-router-dom";

import {
  Box,
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  IconButton
} from "@mui/material";

import {
  Email,
  Facebook,
  Instagram,
  Phone,
  Public,
  AccessTime
} from "@mui/icons-material";

function Footer() {
  return (
    <Box sx={{ background: "#0d0651", color: "#fff", pt: 5, pb: 3 }}>

      <Container>

        <Grid container spacing={4}>

          {/* ABOUT */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              ABOUT
            </Typography>

            <Typography variant="body2">
              <strong>Velvizhi</strong> is a construction company made up of
              teams of experts in construction, approvals, procurement and
              planning. We design, build, transport and maintain projects
              across India while ensuring client satisfaction and quality
              delivery.
            </Typography>
          </Grid>

          {/* CONTACT */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              CONTACT US TODAY..!
            </Typography>

            <List>

              <ListItem sx={{ display: "flex", alignItems: "flex-start" }}>
                <Public sx={{ mr: 1 }} />
                <Typography variant="body2">
                  <strong>Corporate Location:</strong><br />
                  Chennai (Mogappair West), Pincode: 600037, Distt.Thiruvallur
                  (Tamil Nadu)
                </Typography>
              </ListItem>

              <ListItem>
                <Phone sx={{ mr: 1 }} />
                <Typography variant="body2">
                  Contact: +91 9840271137
                </Typography>
              </ListItem>

              <ListItem>
                <Email sx={{ mr: 1 }} />
                <Typography variant="body2">
                  velvizhiconstruction@gmail.com
                </Typography>
              </ListItem>

              <ListItem>
                <AccessTime sx={{ mr: 1 }} />
                <Typography variant="body2">
                  Monday - Friday: 09:00 AM - 5:00 PM
                </Typography>
              </ListItem>

              <ListItem>
                <AccessTime sx={{ mr: 1 }} />
                <Typography variant="body2">
                  Saturday & Sunday Closed
                </Typography>
              </ListItem>

            </List>
          </Grid>

          {/* PLANS */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              PLANS & PRICING
            </Typography>

            <List>
              <ListItem><Typography variant="body2">Basic</Typography></ListItem>
              <ListItem><Typography variant="body2">Essential</Typography></ListItem>
              <ListItem><Typography variant="body2">Premium</Typography></ListItem>
              <ListItem><Typography variant="body2">Premium +</Typography></ListItem>
            </List>
          </Grid>

          {/* SERVICES */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom>
              OUR SERVICES
            </Typography>

            <List>
              <ListItem>
                <Typography variant="body2">
                  Commercial Construction
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="body2">
                  Industrial Construction
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="body2">
                  Residential Construction
                </Typography>
              </ListItem>

              <ListItem>
                <Typography variant="body2">
                  Renovation works
                </Typography>
              </ListItem>
            </List>
          </Grid>

        </Grid>

        {/* SOCIAL ICONS */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 4
          }}
        >

          <IconButton
            component="a"
            href="mailto:velvizhiconstruction@gmail.com"
            color="primary"
          >
            <Email />
          </IconButton>

          <IconButton
            component="a"
            href="https://facebook.com"
            target="_blank"
            color="primary"
          >
            <Facebook />
          </IconButton>

          <IconButton
            component="a"
            href="https://instagram.com"
            target="_blank"
            color="primary"
          >
            <Instagram />
          </IconButton>

        </Box>

        {/* COPYRIGHT */}

        {/* <Box sx={{ textAlign: "center", mt: 3 }}>
          <Typography variant="body2">
            Site Developed By :{" "}
            <Link to="/" style={{ color: "#fff" }}>
              XYZ
            </Link>
          </Typography>
        </Box> */}

      </Container>

    </Box>
  );
}

export default Footer;